<template>
  <v-list-item v-if="visible" id="devInfoButton" link @click="click">
    <v-list-item-title v-t="'Components.MetalinkNavigation.Toolbox'" />
  </v-list-item>
</template>

<script>
export default {
  data: () => ({
    visible: false
  }),
  watch: {
    $route() {
      this.visible = false;
    }
  },
  mounted() {
    window.addEventListener("message", this.setVisibleByIframe, false);
  },
  methods: {
    click() {
      let fusionIframe = document.getElementById("persisMain");
      if (fusionIframe) {
        fusionIframe.contentWindow.postMessage("devInfoButtonClick", "*");
      }
    },
    setVisibleByIframe(event) {
      if (event.data == "devInfoButton") this.visible = true;
    }
  }
};
</script>
